import React from 'react';
import Layout from '../Component/layout/main-layout';
import { Link } from 'react-router-dom';
import {
    CalculateOutlined,
    FolderCopyOutlined,
    FileCopyOutlined,
    GavelOutlined,
    InsertDriveFileOutlined,
    TextSnippetOutlined
} from '@mui/icons-material';
import img1 from '../Images/usefull/pic3.jpg';
import img2 from '../Images/usefull/pic2.jpg';
import img3 from '../Images/usefull/pic5.jpg';
import img4 from '../Images/usefull/pic4.jpg';
import img5 from '../Images/usefull/pic1.jpg';
import img6 from '../Images/usefull/pic6.jpg';
import { useTranslation } from 'react-i18next';
import layoutBgImg from '../Images/layout/services.jpg'
import ServicesLayout from '../Component/layout/services-layout';
import GlobalLayout from '../Component/layout/global-layout';

const data = [
    {
        id: 1,
        name: 'online_appeals',
        icon: <InsertDriveFileOutlined style={{ fontSize: '40px' }} />,
        text: 'lorem ipsum dolor sit amet',
        link: '/electron-filing',
        backgroundImage: img1,
    },
    {
        id: 2,
        name: 'request_copies',
        icon: <FileCopyOutlined style={{ fontSize: '40px' }} />,
        text: 'lorem ipsum dolor sit amet',
        link: '/act-request',
        backgroundImage: img2,
    },
    {
        id: 3,
        name: 'collection_decisions',
        icon: <TextSnippetOutlined style={{ fontSize: '40px' }} />,
        text: 'lorem ipsum dolor sit amet',
        link: '/collection-decisions',
        backgroundImage: img6,
    },
    {
        id: 4,
        name: 'calculator',
        icon: <CalculateOutlined style={{ fontSize: '40px' }} />,
        text: 'lorem ipsum dolor sit amet',
        link: '/calculator',
        backgroundImage: img3,
    },
    {
        id: 5,
        name: 'document_sample',
        icon: <FolderCopyOutlined style={{ fontSize: '40px' }} />,
        text: 'lorem ipsum dolor sit amet',
        link: '/document-sample-list',
        backgroundImage: img4,
    },
    {
        id: 6,
        name: 'sale',
        icon: <GavelOutlined style={{ fontSize: '40px' }} />,
        text: 'lorem ipsum dolor sit amet',
        link: '/sale',
        backgroundImage: img5,
    },
];

const OnlineService = () => {
    const { t } = useTranslation()

    return (
        <GlobalLayout
            title={`${t('online_services')} - ${t('supreme_court')} ${t('turkmenistan')}`}
            keywords="Onlaýn hyzmatlar, Hyzmatlar, Онлайн услуги, Kazyyet hyzmatlary"
        >
            <div className='mb-20'>
                <Layout
                    title={t('online_services')}
                    layoutBgImg={layoutBgImg}
                />

                <ServicesLayout />

                <div className='bg-white dark:bg-dark-box mx-4 xxl:mx-12 
                                  xxxl:mx-32 xxxxl:mx-64 xxxxxl:mx-[400px]                             
                                  xxxxxxl:mx-[650px] xxxxxxxl:mx-[1600px]
                                  xxxxxxxxl:mx-[2400px]'>

                    <div className='grid grid-cols-1 md:grid-cols-2 
                                xl:grid-cols-3 gap-4 p-4 xl:p-8 '>
                        {data?.map((d) => (
                            <Link to={d.link} key={d.id}>
                                <div
                                    className='text-center card h-56 rounded-xl 
                                           py-20 px-2 shadow-sm border border-text
                                           transition-transform duration-500 ease-out                                      
                                           hover:scale-[1.04] hover:shadow-xl'
                                    style={{
                                        backgroundImage: `url(${d.backgroundImage})`,
                                        backgroundSize: 'cover',
                                        backgroundPosition: 'center',
                                    }}
                                >
                                    <div className="overlay h-full w-full absolute 
                                                top-0 left-0 rounded-xl opacity-30
                                                dark:opacity-40">
                                    </div>

                                    <div className='flex flex-col text-white
                                                justify-center items-center'>
                                        <span>
                                            {d.icon}
                                        </span>
                                        <p className='mt-4 font-bold text-xl'>
                                            {t(d.name)}
                                        </p>
                                    </div>
                                </div>
                            </Link>
                        ))}
                    </div>
                </div>
            </div>
        </GlobalLayout>
    );
};

export default OnlineService;
